import MapboxDraw, { DrawCustomMode } from "@mapbox/mapbox-gl-draw";

import { ValidationState } from "fond/draw/validation/helper";

import directSelect from "../../base/directSelect";

import { onTrashAerial } from "./onTrashAerial";

const { constants: Constants } = MapboxDraw;

/**
 * This is a custom mode for direct selecting spans in the aerial planner.
 * We prevent:
 * - moving spans (only poles can be moved),
 * - mid-point creation / display.
 */
const directSelectAerial: DrawCustomMode = {
  ...directSelect,

  onSetup: function (opts) {
    const state = directSelect.onSetup?.call(this, opts);
    this.updateUIClasses({ mouse: Constants.cursors.NONE });

    return state;
  },

  onDrag: function () {
    // We prevent dragging of spans entirely.
  },

  /**
   * We override the toDisplayFeatures method to disable the creation of midpoints.
   */
  toDisplayFeatures: function (state, geojson: GeoJSON.Feature<GeoJSON.LineString>, display) {
    if (geojson.properties && state.featureId === geojson.properties.id) {
      geojson.properties.active = Constants.activeStates.ACTIVE;
    }
    display(geojson);

    // @ts-expect-error incomplete typings from Mapbox
    this.fireActionable(state);
  },

  onMouseDown: function () {
    this.updateUIClasses({ mouse: Constants.cursors.NONE });
  },

  onMouseMove: function () {
    this.updateUIClasses({ mouse: Constants.cursors.NONE });
    // Skip render
    return true;
  },

  onTrash: function (state: ValidationState) {
    onTrashAerial.call(this, this.getSelected(), state);

    // After deletion, switch back to simple select mode
    this.changeMode(Constants.modes.SIMPLE_SELECT, {});
  },
};

export default directSelectAerial;
